// Typelizer digest 2ff4198e3bbfae0c6c01775326cf4d11
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/sales_documents/:sales_document_id/decline */
  create: (
    params: { salesDocumentId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/sales_documents/:sales_document_id/decline', params, options),
    method: 'post',
  }),
}
